import React, { useState } from "react";
import {
  BookOpenCheck,
  Users,
  Banknote,
  BarChart3,
  ShieldCheck,
  ChevronLeft,
  ChevronRight,
  LogOut,
  Home,
  Flag,
  Bell,
  LineChart,
  BadgeCheck,
  Percent,
  CreditCard,
  PieChart,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSideBar";

const adminActions = [
  {
    title: "Manage Courses",
    icon: <BookOpenCheck size={40} />,
    color: "from-blue-500 to-indigo-600",
    path: "/admin/manage-courses",
  },
  {
    title: "Manage Users",
    icon: <Users size={40} />,
    color: "from-green-400 to-emerald-600",
    path: "/admin/users",
  },
  {
    title: "Earnings",
    icon: <Banknote size={40} />,
    color: "from-yellow-400 to-orange-500",
    path: "/admin/earnings",
  },
  {
    title: "Reports",
    icon: <BarChart3 size={40} />,
    color: "from-lime-500 to-green-500",
    path: "/admin/reports",
  },
  {
    title: "Security",
    icon: <ShieldCheck size={40} />,
    color: "from-indigo-500 to-violet-700",
    path: "/admin/security",
  },
  {
    title: "Reported Content",
    icon: <Flag size={40} />,
    color: "from-rose-500 to-red-600",
    path: "/admin/reported-content",
  },
  {
    title: "Send Notifications",
    icon: <Bell size={40} />,
    color: "from-orange-400 to-yellow-500",
    path: "/admin/notifications",
  },
  {
    title: "Course Performance",
    icon: <LineChart size={40} />,
    color: "from-teal-500 to-cyan-600",
    path: "/admin/course-performance",
  },
  {
    title: "Instructor Performance",
    icon: <BadgeCheck size={40} />,
    color: "from-purple-600 to-pink-600",
    path: "/admin/instructor-performance",
  },
  {
    title: "Create Discount Coupons",
    icon: <Percent size={40} />,
    color: "from-fuchsia-500 to-pink-500",
    path: "/admin/discount-coupons",
  },
  {
    title: "Payment Gateway Settings",
    icon: <CreditCard size={40} />,
    color: "from-sky-600 to-blue-600",
    path: "/admin/payment-settings",
  },
  {
    title: "View Platform Reports",
    icon: <PieChart size={40} />,
    color: "from-amber-500 to-yellow-500",
    path: "/admin/platform-reports",
  },
];

const AdminHome = () => {
  const navigate = useNavigate();
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <div className="flex min-h-screen bg-slate-100">
      {/* Sidebar */}

      <AdminSidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Top Navbar */}
        <header className="flex items-center justify-between bg-white p-4 shadow">
          <h1 className="text-2xl font-semibold text-indigo-700">Dashboard</h1>
          <div className="hidden md:block">
            <span className="text-gray-600 font-medium">Welcome, Admin</span>
          </div>
        </header>

        {/* Dashboard Content */}
        <main className="p-6 bg-gradient-to-br from-sky-100 to-blue-200 flex-1">
          <h2 className="text-3xl font-bold text-center text-indigo-800 mb-8">
            Admin Actions
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {adminActions.map((action, index) => (
              <div
                key={index}
                onClick={() => navigate(action.path)}
                className={`bg-gradient-to-br ${action.color} text-white p-6 rounded-2xl shadow-lg hover:scale-105 transform transition cursor-pointer`}
              >
                <div className="flex justify-center mb-4">{action.icon}</div>
                <h3 className="text-xl font-semibold text-center">
                  {action.title}
                </h3>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminHome;
